export default "__VITE_ASSET__88444132__"